const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'PRE_INCUBACAO_PITCH_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'PRE_INCUBACAO_PITCH_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

        case 'PRE_INCUBACAO_PITCH_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

        default:
            return state;
    }
}
